import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef } from "vue"

import LoginIn from "./components/loginIn.vue";
import Register from "./components/register.vue";
import {onBeforeMount, ref} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'login',
  setup(__props) {

let isShow1 = ref(true), isShow2 = ref(false),activeName='login'
onBeforeMount(()=>{
    isShow1.value=true}
)
function updateShow(show1: boolean, show2: boolean) {
  isShow1.value = show1;
  isShow2.value = show2;
  console.log("更新了：")
  console.log("isShow1.value：", isShow1.value)
  console.log("isShow2.value：", isShow2.value)
}

function handleClick(tab:any) {
  if (tab.props.name === 'login') {
    updateShow(true, false);
  } else {
    updateShow(false, true);
  }
}
// function handleClick(tab:any) {
//   if (tab.props.name === 'login') {
//     isShow1.value = true
//     isShow2.value = false
//   } else {
//     isShow1.value = false
//     isShow2.value = true
//   }
// }

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createBlock(_component_el_tabs, {
    type: "border-card",
    class: "demo-tabs",
    onTabClick: handleClick,
    modelValue: _unref(activeName),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(activeName) ? (activeName).value = $event : activeName = $event)),
    stretch: true,
    style: {"height":"100%"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_tab_pane, {
        label: "Log in",
        name: "login"
      }, {
        default: _withCtx(() => [
          (_unref(isShow1))
            ? (_openBlock(), _createBlock(LoginIn, {
                key: 0,
                updateShow: updateShow
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_el_tab_pane, {
        label: "Register",
        name: "register"
      }, {
        default: _withCtx(() => [
          (_unref(isShow2))
            ? (_openBlock(), _createBlock(Register, {
                key: 0,
                updateShow: updateShow
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})